/**
 * Build a Discord CDN avatar URL.
 *
 * Custom avatar: `https://cdn.discordapp.com/avatars/<userId>/<hash>.png?size=128`
 *
 * Default-avatar fallback rules (Discord's "pomelo" username migration split
 * users into two regimes):
 * - Legacy users with a non-zero `discriminator`: index = `parseInt(discriminator) % 5`.
 * - Pomelo users (discriminator absent or '0'): index = `(BigInt(userId) >> 22n) % 6n`.
 *
 * Pinned by Phase 0 verification — update here if Discord changes the rule.
 */
export interface DiscordAvatarInput {
  userId: string;
  avatarHash: string | null;
  /** Legacy discriminator like '0004'. Omit/null/'0' for pomelo users. */
  discriminator?: string | null;
}

export function discordAvatarUrl(input: DiscordAvatarInput): string {
  if (input.avatarHash != null) {
    return `https://cdn.discordapp.com/avatars/${input.userId}/${input.avatarHash}.png?size=128`;
  }
  const disc = input.discriminator;
  if (disc != null && disc !== '0') {
    const index = parseInt(disc, 10) % 5;
    return `https://cdn.discordapp.com/embed/avatars/${index}.png`;
  }
  const index = Number((BigInt(input.userId) >> 22n) % 6n);
  return `https://cdn.discordapp.com/embed/avatars/${index}.png`;
}
